import { defaultCommentPageInfo, defaultPageInfo } from '@/common/constants/ConstCode';

export default {
  initForm: state => {
    state.form = {
      preViewImage: '',
      profileRawFile: null,
      profileFileInfo: null,
      invitationFile: null,
      invitationText: '',
      smileNo: '',
      userNo: '',
      category: '',
      hasSecond: false,
      type: '',
      firstName: '',
      secondName: '',
      eventDate: '',
      eventDateTime: '',
      firstRelation: [
        { relation: '부', name: '' },
        { relation: '모', name: '' }
      ],
      secondRelation: [
        { relation: '부', name: '' },
        { relation: '모', name: '' }
      ],
      address: '',
      buildingName: '',
      parkingNote: '',
      transportNote: '',
      canUseEmo: true,
      hasInvitation: true,
      calculateType: 'CASH',
      onlineStartDate: '',
      onlineEndDate: '',
      firstAccounts: [
        {
          accountHolder: '',
          bank: '선택(은행)',
          accountNumber: ''
        }
      ],
      secondAccounts: [
        {
          accountHolder: '',
          bank: '선택(은행)',
          accountNumber: ''
        }
      ],
      galleryRawFiles: [], // 갤러리에서 새로 등록할 이미지들
      galleryFileList: [], // 기존 저장된 이미지들
      gallery: [],

      alertList: [],
      message: '',
      bgImageNo: ''
    };
  },

  initRelation: (state, payload) => {
    state.form.firstRelation = payload.firstRelation;
    state.form.secondRelation = payload.secondRelation;
  },

  setPreViewImage: (state, preViewImage = '') => {
    state.form.preViewImage = preViewImage;
  },

  setBackgroundPreViewImage: (state, preViewImage = '') => {
    state.backgroundPreViewImage = preViewImage;
  },

  setMessage: (state, message = '') => {
    state.form.message = message;
  },

  setForm: (state, form = {}) => {
    state.form = Object.assign(state.form, form);
  },

  setAlert: (state, alertList = []) => {
    state.form.alertList = alertList;
  },

  setCategory: (state, category = '') => {
    state.form.category = category;
  },

  setStep3: (state, { bgImageNo, message }) => {
    state.form.bgImageNo = bgImageNo;
    state.form.message = message;
  },

  setDetail: (state, data = {}) => {
    state.detail = Object.assign({}, data);
  },

  initComment: state => {
    console.log('Smile initComment');
    state.commentList = [];
    state.pagingCondition = { page: 1, limit: 20, smileNo: '', pageInfo: defaultCommentPageInfo };
  },

  setPage: (state, page = 1) => {
    state.pagingCondition.page = page;
  },

  setPageInfo: (state, pageInfo = {}) => {
    state.pagingCondition.pageInfo = Object.assign({}, pageInfo);
  },

  setCommentList: (state, commentList = []) => {
    state.commentList = [...commentList, ...state.commentList];
  },

  setPlaceList: (state, placeList = []) => {
    state.placeList = placeList;
  },

  appendComment: (state, comment = {}) => {
    state.commentList = [...state.commentList, comment];
  },

  setNextId: (state, nextId = null) => {
    state.nextId = nextId;
  },

  setList: (state, list = []) => {
    state.list = [...state.list, ...list];
  },

  mergeList: (state, list = []) => {
    state.list = list;
  },

  initList: state => {
    state.list = [];
    state.nextId = null;
  },

  setBackground: (state, list = []) => {
    state.background = list;
  }
};
